import { Tooltip } from '@mui/material';
import { observer } from "mobx-react-lite";
import { ButtonHTMLAttributes } from "react";

function ButtonWithTooltip({ title, children, ...props }: IButtonWithTooltipProps & ButtonHTMLAttributes<HTMLButtonElement>) {
    return (
        <Tooltip title={title} arrow>
            <button {...props}>
                {children}
            </button>
        </Tooltip>
    )
}

export default observer(ButtonWithTooltip);

interface IButtonWithTooltipProps {
    title: string;
}
